import {
    areSameNativeInvoicePaymentMethods,
    NATIVE_INVOICE_DEFAULT_PAYMENT_METHODS,
    NativeInvoicePaymentMethod,
} from "@common/constants/nativeInvoicePaymentMethod";

export interface NativeInvoicePaymentMethodOption {
    key: string;
    label: string;
    methods: NativeInvoicePaymentMethod[];
}

export const NATIVE_INVOICE_PAYMENT_METHOD_OPTIONS: NativeInvoicePaymentMethodOption[] =
    [
        {
            key: "card",
            label: "Card and wallets",
            methods: NATIVE_INVOICE_DEFAULT_PAYMENT_METHODS,
        },
        {
            key: "card-ach",
            label: "Card, wallets, and bank transfer (ACH)",
            methods: [
                NativeInvoicePaymentMethod.CARD,
                NativeInvoicePaymentMethod.ACH,
            ],
        },
    ];

const SEPARATOR = "|";

export function paymentMethodPickerValue({
    accountId,
    option,
}: {
    accountId: number;
    option: NativeInvoicePaymentMethodOption;
}): string {
    return `${accountId}${SEPARATOR}${option.key}`;
}

export function parsePaymentMethodPickerValue(
    value: string,
): { accountId: number; option: NativeInvoicePaymentMethodOption } | null {
    const [accountPart, optionKey] = value.split(SEPARATOR);
    const accountId = Number(accountPart);
    const option = NATIVE_INVOICE_PAYMENT_METHOD_OPTIONS.find(
        (candidate) => candidate.key === optionKey,
    );
    if (!Number.isInteger(accountId) || !option) {
        return null;
    }
    return { accountId, option };
}

export function findPaymentMethodOption(
    methods: readonly NativeInvoicePaymentMethod[],
): NativeInvoicePaymentMethodOption {
    return (
        NATIVE_INVOICE_PAYMENT_METHOD_OPTIONS.find((option) =>
            areSameNativeInvoicePaymentMethods(option.methods, methods),
        ) ?? NATIVE_INVOICE_PAYMENT_METHOD_OPTIONS[0]
    );
}
